<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center" dense>
      <v-col cols="4">
        <v-card flat style="background-color: #eeeeee">
          <v-img src="img/nripg-logo-v2-4e1a288b.png" />
          <p class="text-center text-subtitle-2">
            ФГБНУ НАЦИОНАЛЬНЫЙ НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЙ ИНСТИТУТ ОБЩЕСТВЕННОГО
            ЗДОРОВЬЯ ИМ. Н.А.СЕМАШКО
          </p>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card flat style="background-color: #eeeeee">
          <p class="text-center text-h6 text-uppercase">
            Лаборатория инновационных технологий и искусственного интеллекта в
            общественном здравоохранении
          </p>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card flat style="background-color: #eeeeee">
          <v-row align="center" justify="center">
            <v-img
              src="img/nbmz_logo-150x150.png"
              max-height="120"
              max-width="120"
            />

            <p class="text-center text-subtitle-2 text-uppercase">
              Ассоциация "Национальная база медицинских знаний" (НБМЗ)
            </p>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <v-card
          outlined
          elevation="3"
          :to="{ name: 'Cards', params: { application: '0' } }"
        >
          <v-card-title>
            <v-icon>mdi-monitor</v-icon>
            <span class="ml-1">Цифровые технологии</span>
          </v-card-title>
          <v-card-text
            >Сборка научных, организационных и медицинских технологий с
            применением ИТ (IT), в т.ч. ИИ (AI). <br />
            Не является самостоятельным классом технологий, содержит ИТЗ всех
            классов с "признаками цифровизации».
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row> -->

    <v-row>
      <v-col cols="4">
        <v-card
          outlined
          elevation="3"
          :min-height="this.minHeight"
          :to="{ name: 'Cards', params: { application: '3' } }"
        >
          <v-card-title>
            <v-icon>mdi-heart-outline</v-icon>
            <span class="ml-1">
              Медицинские (клинические)<br />
              технологии
            </span>
          </v-card-title>
          <v-card-text>
            Организационные, технические и методические решения, применяемые
            непосредственно в процессе профилактики, диагностики, лечения и
            реабилитации пациентов.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          outline
          elevation="3"
          :min-height="this.minHeight"
          :to="{ name: 'Cards', params: { application: '2' } }"
        >
          <v-card-title>
            <v-icon>mdi-school</v-icon>
            <span class="ml-1">Наука</span>
          </v-card-title>
          <v-card-text>
            Обеспечение научной деятельности, аналитические системы, методики
            исследований и др.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          outlined
          elevation="3"
          :min-height="this.minHeight"
          :to="{ name: 'Cards', params: { application: '1' } }"
        >
          <v-card-title>
            <v-icon>mdi-auto-fix</v-icon>
            <span class="ml-1">
              Организация здравоохранения<br />и общественное здоровье
            </span>
          </v-card-title>
          <v-card-text>
            Организационные, методические, аналитические разработки в целях
            использования в организации здравоохранения.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="1"></v-col>
      <v-col cols="10">
        <v-card flat style="background-color: #eeeeee">
          <p class="text-center text-caption text--secondary">
            ИТЗ (Инновационные технологии в здравоохранении) – организационные,
            методические и технологические решения в совокупности или по
            отдельности обеспечивающие сохранение, укрепление общественного
            здоровья и профилактику его нарушения, в т.ч. системы, процессы и
            технологии поддержки медицинской деятельности и управления
            (поддержки) статусом здоровья индивидуума
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ACTIONS, GETTERS } from "@/store";

export default {
  data: () => ({
    minHeight: "202px",
  }),
  computed: {
    ...mapGetters({ dict4: GETTERS.DICTIONARY_4 }),
    countType0() {
      return 10;
    },
    countType1() {
      return 3;
    },
    countType2() {
      return 1;
    },
    countType3() {
      return 9;
    },
  },
  methods: { ...mapActions({ loadDictionary: ACTIONS.LOAD_DICTIONARY }) },
  mounted() {
    if (this.dict4.length === 0) {
      this.loadDictionary();
    }
  },
};
</script>
